import { Target, IndianRupee, Percent, Calendar } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import formatCurrency from "@/utils/formatCurrency";
import CalculatorInputField from "@/components/shared/CalculatorInputField";
import CalculatorResultCard from "@/components/shared/CalculatorResultCard";
import { useFutureValueCalculator } from "@/hooks/useCalculators";

const FVCalculatorTab = () => {
  const { fvPrincipal, setFvPrincipal, fvRate, setFvRate, fvYears, setFvYears, result } = useFutureValueCalculator();
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="finance-card">
        <h2 className="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2"><Target className="text-teal-600" size={24} /> Lumpsum Growth Calculator</h2>
        <p className="text-gray-600 mb-6">Calculate how much your lump sum investment will grow over time with compound interest.</p>
        <CalculatorInputField label="Principal Amount (Lump Sum)" value={fvPrincipal} onChange={setFvPrincipal} icon={IndianRupee} suffix="₹" />
        <CalculatorInputField label="Expected Annual Return" value={fvRate} onChange={setFvRate} icon={Percent} suffix="%" step={0.5} max={30} />
        <CalculatorInputField label="Investment Period" value={fvYears} onChange={setFvYears} icon={Calendar} suffix="Years" max={40} />
        <div className="grid grid-cols-1 gap-4 mt-6">
          <CalculatorResultCard label="Principal Amount" value={fvPrincipal} colorClass="blue" />
          <CalculatorResultCard label="Interest Earned" value={result.interestEarned} colorClass="green" />
          <CalculatorResultCard label="Future Value" value={result.futureValue} colorClass="teal" large />
        </div>
      </div>
      <div className="finance-card">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Year-wise Growth</h3>
        <ResponsiveContainer width="100%" height={350}>
          <BarChart data={Array.from({ length: fvYears }, (_, i) => ({ year: `Y${i + 1}`, value: Math.round(fvPrincipal * Math.pow(1 + fvRate / 100, i + 1)) }))}><CartesianGrid strokeDasharray="3 3" /><XAxis dataKey="year" tick={{ fontSize: 10 }} /><YAxis tickFormatter={(v) => `₹${(v / 100000).toFixed(0)}L`} /><Tooltip formatter={(v) => `₹ ${formatCurrency(v)}`} /><Bar dataKey="value" name="Value" fill="#14b8a6" radius={[4, 4, 0, 0]} /></BarChart>
        </ResponsiveContainer>
        <div className="mt-4 p-4 bg-green-50 rounded-lg border border-green-200"><p className="text-sm text-gray-700"><span className="font-semibold">Power of Compounding:</span> Your ₹{formatCurrency(fvPrincipal)} will grow to <span className="font-bold text-green-600"> ₹{formatCurrency(result.futureValue)}</span> in {fvYears} years at {fvRate}% annual return.</p></div>
      </div>
    </div>
  );
};

export default FVCalculatorTab;
